"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayNamesHeaderContainer = exports.DayName = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const media_1 = require("../../../../../utils/media");
const Typography_1 = require("../../../../atoms/Typography");
const DayNamesHeaderContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.DayNamesHeaderContainer = DayNamesHeaderContainer;
const DayName = (0, styled_components_1.default)(Typography_1.H4) `
  height: auto;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-size: 10px;
  margin-bottom: 15px;
  @media (${media_1.media.smallDesktop}) {
    font-size: 14px;
  }
`;
exports.DayName = DayName;
